module.exports = __webpack_public_path__ + "img/r_game_images_01.1128fa48.png";